import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Upload, Icon } from 'antd';
import styles from './style.less';
import { s3Host } from "../../../../utils";

// const getBase64 = (img, callback) => {
//   const reader = new FileReader();
//   reader.addEventListener('load', () => callback(reader.result));
//   reader.readAsDataURL(img);
// };

class ImagesField extends Component {
  constructor(props) {
    super(props);
  }

  handleChange = ({ fileList, file }) => {
    if (file.status === 'done') {
      console.log('file: ', file);
      // Get this url from response in real world.
      file.link = file.response && file.response.data.link;
      // getBase64(file.originFileObj, (imageUrl) => {
      //   console.log({ imageUrl });
      //   file.link = imageUrl;
      // });
    }

    this.forceUpdate();
    this.props.onChange(fileList);
    // this.setState({
    //   fileList
    // }, () => { this.props.onChange(fileList) })
  }

  // handleRemove= () {

  // }

  render() {
    const options = {
      action: '/rest/store_product/upload_image',
      multiple: true,
      accept: 'image/*',
      listType: 'picture-card',
      showUploadList: false,
      fileList: this.props.formData || [],
      onChange: this.handleChange,
    };
    console.log('options.fileList: ', options.fileList);

    if (options.fileList.length) {
      options.fileList.forEach((element) => {
        if (element.response) {
          element.link = element.response.data.link;
        }
      });
    }

    return (
      <div className={styles.satUploader}>
        <div className="ant-upload-list ant-upload-list-picture-card">
          {
            options.fileList.map(item => (
              <div key={item.uid} className="ant-upload-list-item">
                <div className="ant-upload-list-item-info">
                  { item.status === 'done' ?
                    <span>
                      <a className="ant-upload-list-item-thumbnail">
                        <img src={`${s3Host}${item.link}`} alt="" />
                      </a>
                    </span>
                    :
                    <span>
                      uloading...
                    </span>

                  }
                </div>
                <span className="ant-upload-list-item-actions">
                  <a href="/" target="_blank" rel="noopener noreferrer" title="Preview file">
                    <i className="anticon anticon-eye-o" />
                  </a>
                  <Icon type="trash" className="anticon-delete" onClick={this.handleRemove} />
                </span>
              </div>
            ))
          }
        </div>
        <Upload {...options}>
          <div>
            <Icon type="plus" />
            <div className="ant-upload-text">нэмэх</div>
          </div>
        </Upload>
      </div>
    );
  }
}

ImagesField.defaultProps = {
  formData: [],
};

ImagesField.propTypes = {
  formData: PropTypes.array,
  onChange: PropTypes.func.isRequired,
};

export default ImagesField;



// WEBPACK FOOTER //
// ./src/components/OrderForm/FieldTemplates/ImagesFieldTemplate/index.js